import RMSvgIcon, {
  RMSvgIconProps,
} from 'components/customComponents/CommonComponents/RMSvgIcon';
import React, { useState } from 'react';
import { IStyle } from 'Styles';
import { useCrystalStates } from 'components/Experiment/Harvesting/Crystal/hooks';
import { useRMSelector } from 'redux/hooks';
import SynchrotronTripService from 'business/services/SynchrotronTripService';
import { RMModal } from 'components/modal';
export interface AccordionCardProps {
  icon?: RMSvgIconProps;
  heading: string;
  subHeading?: string;
  active: boolean;
  activeClass?: string;
  headingTooltip?: string;
  customStyle?: React.CSSProperties;
  onClick?: any;
  onDblClick?: any;
  onDelete?: any;
}
type ModalStateType = {
  showModal: boolean;
  body: any;
  heading: string;
  onOk?: () => void;
  noButtonText?: string;
  dialogClassName?: string;
  isCancelOnly: boolean;
};

const AccordionCards = (props: AccordionCardProps) => {
  const {
    heading,
    subHeading,
    icon,
    active,
    activeClass,
    headingTooltip,
    customStyle,
    onClick,
    onDblClick,
    onDelete,
  } = props;
  const { selectedTripCrystals } = useCrystalStates();
  const [modalStates, setModalStates] = useState<ModalStateType>({
    showModal: false,
    body: <div id="accordion-cards-modal-waitingmessage">Please Wait</div>,
    heading: 'ROCK MAKER',
    onOk: null,
    noButtonText: 'Cancel',
    dialogClassName: null,
    isCancelOnly: true,
  });
  const selectedTripId = useRMSelector((state) => state.synchrotronTrip.selectedTripId);

  const setShowModal = () => {
    setModalStates({ ...modalStates, showModal: false });
  };

  const showDeleteTripConfirm = async () => {
    const synchTripService = new SynchrotronTripService();
    const isTripResultsExist: boolean =
      await synchTripService.isSynchTripCrystalsResultsExist(selectedTripId);
    let body: any = null;
    let onOk: any = null;
    let isCancelOnly = true;
    if (isTripResultsExist) {
      body = (
        <div id="accordion-cards-modal-deltripconfirm-wrapper">
          <text id="accordion-cards-modal-deltripconfirm">
            Trip (
            <b id={`accordion-cards-modal-deltripconfirm`}>
              {' '}
              {headingTooltip.toString()}{' '}
            </b>
            ) cannot be removed from experiment because the assigned crystals have Trip
            Results.
          </text>
        </div>
      );
    } else {
      onOk = onDelete;
      isCancelOnly = false;
      body = (
        <div id="accordion-cards-modal-deltripconfirm-cancel-wrapper">
          <text id="accordion-cards-modal-deltripconfirm-cancel">
            Are you sure you want to remove (
            <b id={`accordion-cards-modal-deltripconfirm-cancel-headingtooltip`}>
              {headingTooltip.toString()}
            </b>
            ) in this experiment?
            {selectedTripCrystals && (
              <>
                <br />
                There is (
                <b id={`accordion-cards-modal-deltripconfirm-selected-headingtooltip`}>
                  {selectedTripCrystals.length}
                </b>
                ) crytals assigned in this synchrotron trip, when you remove this
                synchrotron trip the crystal will move to unassign crystal.
              </>
            )}
          </text>
        </div>
      );
    }

    setModalStates({
      ...modalStates,
      showModal: true,
      heading: 'Remove Synchrotron Trip',
      onOk: onOk,
      dialogClassName: '!max-w-4xl !w-1/3',
      body: body,
      isCancelOnly: isCancelOnly,
    });
  };

  return (
    <>
      <div id="accordion-cards-wrapper" data-testid="accordion-cards-wrapper">
        <div
          id="accordion-cards-pointer"
          data-testid="accordion-cards-pointer"
          className={`${
            active && activeClass
          } cursor-pointer relative h-10 w-32 hover:bg-blue-100`}
          onClick={onClick}
          onDoubleClick={onDblClick}
          style={{ ...styles.root, ...customStyle }}
        >
          {active && onDelete && (
            <RMSvgIcon
              id="accordion-cards-remove-icon"
              data-testid="accordion-cards-remove-icon"
              onClick={showDeleteTripConfirm}
              name="Remove"
              width={15}
              height={15}
              className="absolute -top-2 -right-2"
            />
          )}
          <div
            id="accordion-cards-content"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            {icon && (
              <div
                id="accordion-cards-icon-wrapper"
                data-testid="accordion-cards-icon-wrapper"
                style={{ paddingInline: '8%' }}
              >
                <RMSvgIcon
                  id={`accordion-cards-${icon.name}`}
                  data-testid={`accordion-cards-${icon.name}`}
                  name={icon.name}
                  fill="none"
                  width={20}
                  height={20}
                />
              </div>
            )}
            <div id="accordion-cards-text">
              <div
                id={`accordion-cards-${heading}`}
                style={styles.heading}
                title={headingTooltip}
              >
                {heading}
              </div>
              {subHeading && (
                <div
                  id={`accordion-cards-${subHeading}`}
                  data-testid={`accordion-cards-${subHeading}`}
                  style={styles.subHeading}
                >
                  {subHeading}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <RMModal {...modalStates} setShowModal={setShowModal} />
    </>
  );
};
const styles: IStyle = {
  root: {
    outline: '2px solid #CCC',
    border: '1px solid #999',
    borderRadius: '5px',
    paddingTop: '2%',
    margin: '1%',
    paddingBottom: '1%',
    width: '7vw',
    height: '5vh',
  },
  heading: {
    fontSize: 12,
  },
  subHeading: {
    color: '#808080',
    fontSize: 10,
  },
};
export default AccordionCards;
